// Client mirror of functions-common/src/charts/engine/sort.ts. Keep in sync.

import type { ChartSeries } from '../types.js'

export function sortSeriesPoints(
  seriesList: ChartSeries[],
  sortStyle?: 'value-desc' | 'value-asc' | 'label',
  isTimeSeries: boolean = false
): ChartSeries[] {
  return seriesList.map((series) => {
    const points = [...series.points]

    if (sortStyle === 'value-desc') {
      points.sort((a, b) => b.y - a.y)
    } else if (sortStyle === 'value-asc') {
      points.sort((a, b) => a.y - b.y)
    } else if (sortStyle === 'label') {
      points.sort((a, b) => String(a.x).localeCompare(String(b.x)))
    } else if (isTimeSeries) {
      // Default for time series: chronological ascending
      points.sort((a, b) => String(a.x).localeCompare(String(b.x)))
    }

    return {
      ...series,
      points,
    }
  })
}
